import {gsap} from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

export default class Main{

    constructor(){
        this.init();
    }


    init(){
        this.toTop();

        window.addEventListener('load', () => {
            document.body.classList.add('-ready')
        })
        
    }


    toTop() {
        const trigger = document.querySelector('.js-pageup');

        trigger.addEventListener('click', (e) => {
            gsap.to(window, {duration: 0.8, scrollTo: {y: 0}, ease: 'expo.inOut'});
        });
    }
}